import styled from "styled-components";
import ModeHintMessage from "./modeHintMessage";
export const SIZES = {
    ICOMOON_FONT_SIZE: 30,
    ICOMOON_TEXT_OFFSET_Y: -9,
    ICON_ANCHOR: [0.5, 0.8],
    MODE_HINT_MESSAGE_MARGIN: 30,
    HINT_WIDTH: 330
};
export default {
    ModeHintMessage: styled(ModeHintMessage).attrs({
        className: "position-absolute"
    }) `
    width: ${SIZES.HINT_WIDTH}px;
    right: ${SIZES.MODE_HINT_MESSAGE_MARGIN}px;
    bottom: ${SIZES.MODE_HINT_MESSAGE_MARGIN}px;
    z-index: ${({ theme }) => theme["zindex-devextreme-dx-menu-base"]};
  `
};
